(ns ncr.core
  (:require
   [clojure.core.match :refer [match]]
   [lambdaisland.glogi.console :as glogi-console]
   [lambdaisland.glogi :as log]
   [uix.core.alpha :as uix]
   [uix.dom.alpha :as uix.dom]
   [ncr.auth :as a]
   [ncr.backend-http :as bh]
   [ncr.widgets.core :as w]
   [ncr.me :as me]
   [ncr.etc.util :as u]
   [ncr.manage.accounts]
   [ncr.manage.generic]
   [ncr.manage.labels]
   [ncr.manage.folders]
   [ncr.manage.ai-assist]
   [ncr.manage.datev]
   [ncr.cluster :as cluster]
   [ncr.sidebar :as sidebar]
   [ncr.search :as search]
   [ncr.fragment.core :as fragment]
   [ncr.etc.reload :as rel]
   [ncr.etc.pf :as pf]
   [ncr.manage.preferences :as preferences]
   [reitit.frontend :as rf]
   [ncr.reports.core]
   [ncr.etc.modal :as modal]
   [ncr.etc.alert :as alert]
   [ncr.scratch :as scratch]
   [ncr.sysinfo]
   [ncr.masthead]
   [ncr.navigate :as nav]
   [ncr.tour :as tour]))

(def ^:private routes
  (rf/router
    [["/" {:name :root :redirect-to [:search {:query ""}]}]
     ["/search"
      ["" {:component #'search/c-search :query ""}]
      ["/*query" {:name :search :component #'search/c-search}]]
     ["fragment/:id" {:name :fragment :component #'fragment/c-fragment}
      [""]
      ["/:slug"
       ["" :fragment-slug]
       ["/attachment/:attachment-id" :fragment-slug-attachment]]]
     ["reports" {:name :reports :component #'ncr.reports.core/report}]
     ["manage/"
      ["accounts" {:name :manage-accounts :component #'ncr.manage.accounts/c-manage-accounts}]
      ["labels" {:name :manage-labels :component #'ncr.manage.labels/c-manage-labels}]
      ["folders" {:name :manage-folders :component #'ncr.manage.folders/c-manage-folders}]
      ["assist" {:name :manage-assist :component #'ncr.manage.ai-assist/c-page}]
      ["datev" {:name :manage-datev :component #'ncr.manage.datev/c-page}]]
     ["scratch" {:name :scratch :component #'scratch/c-scratch}]]))

(defn c-root []
  (let [available (bh/use-available)]
    (if-let [route-data (nav/use-router routes)]
      [:<>
       [modal/c-modal-container :outer]
       (match available
         [:available]
         [a/c-with-authenticated
          [ncr.cluster/c-with-cluster
           [ncr.me/c-with-me
            [preferences/c-with-preferences
             [:<>
              [modal/c-modal-container :inner]
              [alert/c-alert-container]
              [ncr.sysinfo/c-about]
              [tour/c-tour route-data]
              [pf/c-page
               {:header
                [w/c-error-boundary
                 [ncr.masthead/c-masthead route-data]]
                :sidebar
                [w/c-error-boundary
                 [sidebar/c-sidebar]]
                :is-managed-sidebar true}

               (if-let [to (get route-data :redirect-to)]
                 (do (apply nav/replace-state! to)
                   nil)
                 (let [component (get route-data :component)]
                   [w/c-error-boundary
                    (if (fn? component)
                      [component route-data]
                      [w/c-bare-status (u/format "Invalid component for route: %s" (:name route-data))])]))]]]]]]

         _
         nil)]
      [w/c-bare-status
       (let [location (.-location js/document)]
         (u/format "Invalid route: %s%s%s" (.-pathname location) (.-search location) (.-hash location)))])))

(defn ^:dev/after-load mount-root []
  (uix.dom/render [#'c-root]
    (.getElementById js/document "app"))
  (rel/reloaded!))

(defn init []
  (glogi-console/install!)
  (log/set-levels
    {:glogi/root :all})

  #_(set! (.-LOG_LEVEL js/window) "DEBUG")

  (mount-root))